class RotatingCollection extends HTMLElement{
    constructor(){
        super();
        this.display();
    }

    display(){
        document.querySelectorAll("[data-randomize-products]").forEach((grid) => {
            const productCards = Array.from(grid.children);
            const productLimit = Number.parseInt(grid.dataset.productLimit, 10);

            for (let index = productCards.length - 1; index > 0; index -= 1) {
                const randomIndex = Math.floor(Math.random() * (index + 1));
                [productCards[index], productCards[randomIndex]] = [productCards[randomIndex], productCards[index]];
            }

            productCards.slice(0, productLimit).forEach((card) => grid.appendChild(card));
            productCards.slice(productLimit).forEach((card) => card.remove());
        });

        var elements=document.querySelectorAll("div[id='hiddendisplay']");
        elements.forEach((element) => {
            element.toggleAttribute("hidden");
        });

    }
}

customElements.define('rotating-collection', RotatingCollection);